module.exports = __webpack_public_path__ + "img/user-down-02.efd4faeb.svg";